import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import {
    ClientInterface,
    ContractInterface,
    DisinvestmentInterface,
    FeeInterface,
    FileInterface,
    IdInterface,
    ModelInterface,
    OrderClientInterface,
    TransferInterface,
    ValidModelInterface,
} from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class TransferApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    evaluateFee(contractCode: IdInterface, evaluateFee: FeeInterface): Observable<Transaction<number>> {
        return this.transactionRequest.wrap(this.apiClient.evaluateFee(contractCode, evaluateFee));
    }

    getModel(id: IdInterface): Observable<Transaction<ModelInterface>> {
        return this.transactionRequest.wrap(this.apiClient.getModel(id));
    }

    getModelPdf(id: IdInterface): Observable<Transaction<FileInterface>> {
        return this.transactionRequest.wrap(this.apiClient.getModelPdf(id));
    }

    getValidModels(contract: ContractInterface, client: ClientInterface): Observable<Transaction<ValidModelInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getValidModels(contract, client));
    }

    setFee(contractCode: IdInterface, fee: FeeInterface): Observable<Transaction<boolean>> {
        return this.transactionRequest.wrap(this.apiClient.setFee(contractCode, fee));
    }

    setTransfer(transfer: TransferInterface): Observable<Transaction<boolean>> {
        return this.transactionRequest.wrap(this.apiClient.setTransfer(transfer));
    }

    signDisinvestment(
        contractCode: IdInterface,
        signatories: OrderClientInterface[],
        disinvestment: DisinvestmentInterface
    ): Observable<Transaction<boolean>> {
        return this.transactionRequest.wrap(this.apiClient.signDisinvestment(contractCode, signatories, disinvestment));
    }

    signModel(contractCode: IdInterface, signatories: OrderClientInterface[], modelId: IdInterface): Observable<Transaction<boolean>> {
        return this.transactionRequest.wrap(this.apiClient.signModel(contractCode, signatories, modelId));
    }

    signTransfer(
        contractCode: IdInterface,
        signatories: OrderClientInterface[],
        transfer: TransferInterface
    ): Observable<Transaction<boolean>> {
        return this.transactionRequest.wrap(this.apiClient.signTransfer(contractCode, signatories, transfer));
    }
}
